import React, { useMemo, useState } from 'react';
import { Colors } from '../../../ui';
import { TextButton } from '../../../ui/TextButton';
import { useResolve } from '../../Container';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { AssistantToolRegistry } from './AssistantToolRegistry';
import { ToolCallPart } from './ChatTypes';

const useToolCallView = (toolName: string): React.NamedExoticComponent<ToolCallPart> => {
    const registry = useResolve(AssistantToolRegistry);
    return useMemo(() => {
        const support = registry.get(toolName);
        console.log(support?.ui);
        return support?.ui ?? DefaultToolCallView;
    }, [toolName]);
};

const DefaultToolCallView = React.memo<ToolCallPart>(({ toolName, args }) => {
    const [showArgs, setShowArgs] = useState(false);
    return <>
        <Copy flush style={{ fontStyle: 'italic' }}>
            Calling {toolName}...
        </Copy>
        {!showArgs && <TextButton onClick={() => setShowArgs(!showArgs)}>Show Args</TextButton>}
        {showArgs && <TextButton onClick={() => setShowArgs(!showArgs)}>Hide Args</TextButton>}
        {showArgs && <Flexer style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(args, null, 2)}</Flexer>}
    </>;
});

export const StreamedToolCall = React.memo<ToolCallPart>((props) => {

    const View = useToolCallView(props.toolName);
    console.log('WTFF', View);

    return <Flexer>
        <Flexer border={`solid 1px ${Colors.border}`} borderRadius=".5" padding=".5">
            <View {...props} />
        </Flexer>
    </Flexer>;
});
